export default class SubscribeNewsletter {
    constructor(component) {
        this.component = component;
        this.init();
    }
    init() {
        const self = this;
        self.form = self.component.querySelector('form');
        self.thankYouMessage = self.component.querySelector('.thank-you-message');
        self.formWrapper = self.component.querySelector('.form-wrapper');
        self.form.addEventListener('submit', (e) => {
            e.preventDefault();
            self.submitForm();
        });
    }
    submitForm() {
        const formData = new FormData(this.form);
        const options = {
            method: 'POST',
            body: formData
        };
        fetch(window.localize_script.admin_ajax, options)
            .then(response => response.json())
            .then(data => {
            if (data.success) {
                this.successMessage();
            }
        });
    }
    successMessage() {
        this.form.reset();
        this.component.classList.add('submitted');
    }
}
